<script setup lang="ts">
import LegacyRewardModal from '@/views/reward/components/RewardModal.vue'
import NewRewardModal from '@/components/rewards/RewardModal.vue'
import { buildContestRewardSavePayload } from '../utils'

import type { LoyaltyReward } from '@/types/types'
import { useRewardForm } from '@/components/rewards/compmosable/useRewardForm'

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'saved', rewardId: number): void
}>()

const { t } = useI18n()
const { saveReward } = useRewardForm()
const notification = useNotification()
const { flags } = useFeatureFlag()

const RewardModal = computed(() => (flags.value['offer-engine']?.enabled ? NewRewardModal : LegacyRewardModal))

const handleSaveReward = async (reward: LoyaltyReward) => {
  const payload = buildContestRewardSavePayload(reward, !!flags.value['offer-engine']?.enabled)
  if (!payload) return

  try {
    const savedReward = await saveReward(payload)
    notification.create('success', {
      text: t('pages.reward.createReward.success')
    })
    emit('saved', savedReward.id)
  } catch {
    notification.create('error', {
      text: t('pages.reward.editReward.error')
    })
  }
}
</script>

<template>
  <RewardModal usage="contest" hide-claim-limit-block @close="emit('close')" @update:reward="handleSaveReward" />
</template>
